var DiacriticsRemovalMap = [
  // Liste des diacritiques - NON EXHAUSTIF
  [(/[\u00E1\u00E0\u00E2\u00E4\u00E3\u00E5\u0101\u0103\u0105\u00C3\u00C0]/gi), 'A'],
  [(/[\u00E9\u00E8\u00C8\u00CA\u00EA\u00CB\u00EB\u00C9]/gi), 'E'],
  [(/[\u00ED\u00CD\u00EC\u00CC\u00EE\u00CF\u00EF\u012B\u012D\u012C\u012Fi]/gi), 'I'],
  [(/[\u00E7\u00C7]/gi), 'C'],
  [(/[\u0135]/gi), 'J'],
  [(/[\u00F2\u00D2\u00F3\u00D3\u00F4\u00D4\u00F5\u00D5\u00F6\u00D6\u00F8\u00D8]/gi), 'O'],
  [(/[\u00F9\u00FA\u00FB\u00FC\u016F\u016D\u00DC\u00DB\u00D9]/gi), 'U'],
  [(/[\u00F1\u00D1]/gi), 'N'],
  [(/[\u00FD\u00FF]/gi), 'Y'],
  [(/[\u00DF]/gi), 'SS'],
  // Liste des ligatures - NON EXHAUSTIF
  [(/\u0153/gi), 'OE'],
  [(/\u00E6/gi), 'AE'],
  [(/\u0133/gi), 'IJ'],
  // Liste des caracteres non alphanumeriques et doublons d'espace
  [(/[\W_\s]+/gi), ' '],
  // Trim
  [(/^\s*(.+?)\s*$/gi), '$1']
]

var removeDiacritics = function (str) {
  for (var i = 0, l = DiacriticsRemovalMap.length; i < l; i++) {
    str = str.replace(
      DiacriticsRemovalMap[i][0],
      DiacriticsRemovalMap[i][1])
  }

  return str
}

var no_title = 'Non renseigné'
// var no_title = '<span class="i">Non renseigné</span>'

var clean_str = function (str) {
  return removeDiacritics(str).toUpperCase()
}

var get_display = function (sel, index) {
  // convert id array to data array
  // je sui pas sur qu'on ait encore
  // besoin de cete fonction
  // console.log("display", sel)
  var items = [],
    ref = index.ref,
    list = index.list,
    l = sel.length,
    id,
    r,
    store = {}

  // console.log('list', list)

  for (var i = 0; i < l; i++) {
    id = sel[i]
    r = ref[id]
    if (!store[id]) {
      if (typeof r === 'undefined' ||
      typeof list[r] === 'undefined') {
        // console.log(r)
        items.push({
          id: id,
          n: no_title
        })
      }
      else {
        items.push(list[r])
      }
      store[id] = true
    }
  }

  return items
}

var array_big_intersect = function (arr) {
  // console.log('big_intersect', arr)
  // var args = Array.prototype.slice.call(arguments),
  var args = arr,
    aLower = [],
    aStack = [],
    count,
    i,
    nArgs,
    nLower,
    oRest = {},
    oTmp = {},
    value,
    compareArrayLength = function (a, b) {
      return (a.length - b.length)
    },
    indexes = function (array, oStack) {
      var i = 0,
        value,
        nArr = array.length,
        oTmp = {}

      for (; nArr > i; ++i) {
        value = array[i]
        if (!oTmp[value]) {
          oStack[value] = 1 + (oStack[value] || 0) // counter
          oTmp[value] = true
        }
      }

      return oStack
    }

  args.sort(compareArrayLength)
  aLower = args.shift()
  nLower = aLower.length

  if (nLower === 0) {
    return aStack
  }

  nArgs = args.length
  i = nArgs
  while (i--) {
    oRest = indexes(args.shift(), oRest)
  }

  for (i = 0; nLower > i; ++i) {
    value = aLower[i]
    count = oRest[value]
    if (!oTmp[value]) {
      if (nArgs === count) {
        aStack.push(value)
        oTmp[value] = true
      }
    }
  }

  return aStack
}

var filter_list = function (tt, index, sel, filter) {
  var ctt = clean_str(tt),
    words = ctt.split(' '),
    wl = words.length,
    w,
    list = index.list,
    ind = index.index,
    listFound = [],
    selection = !!sel,
    wSize,
    chars,
    cl,
    c,
    indexTmp,
    indexKey,
    found,
    res = []

  if (ctt === '') {
    if (selection) {
      return get_display(sel, index)
    }
    else {
      return list
    }
  }

  for (var j = 0; j < wl; j++) { // for each word
    w = words[j]
    chars = w.split('')
    cl = chars.length
    if (cl === 0) continue
    indexKey = ind
    found = true

    for (var k = 0; k < cl; k++) { // for each char
      c = chars[k]

      // console.log('char', c, indexKey, indexKey[c])
      indexTmp = indexKey[c]
      if (typeof indexTmp === 'undefined') {
        found = false
        break
      }
      indexKey = indexTmp[1]
    }

    // console.log('found && indexTmp', found, indexTmp)

    if (found && indexTmp) {
      if (filter) {
        let block = []
        indexTmp[0].forEach(function (item_id) {
          let item_ref = index.ref[item_id]
          let item = index.list[item_ref]

          // console.log('filter', index.list[index.ref[item_id]])
          if (filter(item)) {
            block.push(item_id)
          }
        })
        if (block.length > 0) {
          res.push(block)
        }
      }
      else {
        res.push(indexTmp[0])
      }
    }
  }

  if (sel && selection) {
    res.push(sel)
  }
  var arr
  // console.log("res.length", res.length)
  if (res.length > 1) {
    arr = array_big_intersect(res)
  }
  else {
    arr = res[0]
  }
  if (arr) {
    listFound = get_display(arr, index)
  }
  else {
    listFound = []
  }

  return listFound
}

export default {
  filter_list: filter_list,
  removeDiacritics: removeDiacritics,
  // array_big_intersect: array_big_intersect,
  get_display: get_display,
  get_name: function (id, index) {
    var ref = index.ref[id]

    if (typeof ref === 'undefined' ||
      typeof index.list[ref] === 'undefined') {
      return '<span class="i">' + no_title + '</span>'
    }

    return index.list[ref].n
  }
}
